import urljoin from 'url-join';
import { EmbedConfig } from '../..';
import render from '../../designs/paper';

import MontserratWoff2 from '../../../../../../client/assets/Montserrat-Regular.woff2';
import PlayfairWoff2 from '../../../../../../client/assets/PlayfairDisplay-Regular.woff2';
import './styles/style.scss';

const additionalFonts = (config: EmbedConfig) => {
  const MontserratWoff2Path = urljoin(config.goBaseUrl, MontserratWoff2);
  const PlayfairWoff2Path = urljoin(config.goBaseUrl, PlayfairWoff2);

  return `
    @font-face {
      font-family: 'Montserrat';
      font-style: normal;
      src: url('${MontserratWoff2Path}') format('woff2');
    }
      
       @font-face {
      font-family: 'Playfair';
      font-style: normal;
      ascent-override: 87%;
      descent-override: 14%;
      line-gap-override: 0%;
      src: url('${PlayfairWoff2Path}') format('woff2');
    }`;
};

render(additionalFonts);
